import { resolveAssetUrl } from './resolveAssetUrl';

export function departmentImageSrc(image, { size = 'thumb' } = {}) {
  if (!image) return '';
  const raw =
    size === 'large'
      ? image?.large || image?.url || image?.medium
      : image?.thumbnail || image?.url;
  return resolveAssetUrl(raw);
}

export function preloadDepartmentImages(sources, limit = 6) {
  if (!Array.isArray(sources)) return;
  sources.slice(0, limit).forEach((src, index) => {
    if (!src) return;
    const img = new Image();
    img.decoding = 'async';
    if (index === 0) img.fetchPriority = 'high';
    img.src = src;
  });
}

export function getDepartmentImageSources(departmentsRes) {
  const list = departmentsRes?.data || departmentsRes || [];
  if (!Array.isArray(list)) return [];
  return list.map((d) => departmentImageSrc(d.image)).filter(Boolean);
}
